import { Stethoscope } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import type { LabVisit } from "@/lib/api_client";
import { ConsultationVitals } from "./ConsultationVitals";
import { ConsultationNotesList } from "./ConsultationNotesList";
import { ConsultationFollowupSuggestions } from "./ConsultationFollowupSuggestions";

export function ConsultationPanel({ labVisit }: { labVisit: LabVisit }) {
  if (!labVisit.companyId) return null;

  return (
    <>
      <ConsultationFollowupSuggestions labVisit={labVisit} />
      <Card className="border-l-4 border-l-admin-warn-400/70">
        <CardContent className="p-0">
          <div className="flex items-center gap-1.5 p-2.5 text-xs font-semibold text-admin-warn-300">
            <Stethoscope className="h-3.5 w-3.5" />
            Notater fra konsultasjon
          </div>
          <div className="border-t border-admin-card-border p-2.5 space-y-3">
            <ConsultationNotesList labVisitId={labVisit.id} />
            <ConsultationVitals authUserId={labVisit.authUserId} />
          </div>
        </CardContent>
      </Card>
    </>
  );
}
